import React, { useState, useEffect } from 'react';
import { db, storage, auth } from '../../../Firebase/Firebase';
import { doc, collection, getDoc, getDocs, updateDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { onAuthStateChanged } from 'firebase/auth';
import { useParams, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import './CrearServicio.css'; // puedes usar el mismo CSS de CrearServicio
import Navbar from '../../../Components/NavBarAirbnbStyle';
import Footer from '../../../Components/footer';
import MapaSeleccion from '../../../Components/maps/MapaSeleccion';
import NavbarMobileVersion from '../../../Components/NavBar/NavBarMobileVersion';

const EditarServicio = () => {
  const { id } = useParams(); // id servicio para editar
  const navigate = useNavigate();

  const [uid, setUid] = useState(null);
  const [fotoFile, setFotoFile] = useState(null);
  const [servicio, setServicio] = useState(null);

  const [categorias, setCategorias] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [portafolioFiles, setPortafolioFiles] = useState([]);
  const [portafolioURLs, setPortafolioURLs] = useState([]);

  // Detectar usuario autenticado
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => {
      if (user) setUid(user.uid);
      else setUid(null);
    });
    return unsub;
  }, []);

  // Cargar categorías
  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'categorias'));
        const cats = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCategorias(cats);
      } catch (error) {
        console.error('Error cargando categorías:', error);
      }
    };
    cargarCategorias();
  }, []);

  // Cargar datos servicio existente
  useEffect(() => {
    const cargarServicio = async () => {
      try {
        const docRef = doc(db, 'servicios', id);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          setServicio({
            ...data,
            ubicacion: data.ubicacion || null,
          });
          setPortafolioURLs(data.portafolio || []);

        }
      } catch (error) {
        console.error('Error cargando servicio:', error);
      }
    };
    cargarServicio();
  }, [id]);

  const handlePortafolioChange = (e) => {
    const nuevos = Array.from(e.target.files);
    setPortafolioFiles((prev) => [...prev, ...nuevos]);
  };

  if (!servicio) return <p>Cargando servicio...</p>;

  // Cambios en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setServicio(prev => ({ ...prev, [name]: value }));
  };

  // Cambios FAQ dinámicos
  const handleFaqChange = (index, field, value) => {
    const newFaq = [...servicio.faq];
    newFaq[index][field] = value;
    setServicio(prev => ({ ...prev, faq: newFaq }));
  };
  const setUbicacion = (loc) => {
    setServicio(prev => ({ ...prev, ubicacion: loc }));
  };

  const agregarFaq = () => {
    if (servicio.faq.length < 5) {
      setServicio(prev => ({ ...prev, faq: [...prev.faq, { pregunta: '', respuesta: '' }] }));
    }
  };

  const eliminarFaq = (index) => {
    const newFaq = servicio.faq.filter((_, i) => i !== index);
    setServicio(prev => ({ ...prev, faq: newFaq }));
  };

  // Cambios paquetes dinámicos
  const handlePaqueteChange = (index, field, value) => {
    const newPaquetes = [...servicio.paquetes];
    newPaquetes[index][field] = value;
    setServicio(prev => ({ ...prev, paquetes: newPaquetes }));
  };

  const agregarPaquete = () => {
    if (servicio.paquetes.length < 3) {
      setServicio(prev => ({ ...prev, paquetes: [...prev.paquetes, { nombre: '', descripcion: '', precio: '' }] }));
    }
  };

  const eliminarPaquete = (index) => {
    const newPaquetes = servicio.paquetes.filter((_, i) => i !== index);
    setServicio(prev => ({ ...prev, paquetes: newPaquetes }));
  };

  // Manejar cambio de archivo foto
  const handleFotoChange = (e) => {
    if (e.target.files[0]) setFotoFile(e.target.files[0]);
  };

  // Validar
  const validar = () => {
    if (!servicio.categoria) return 'Debe seleccionar una categoría.';
    if (!servicio.nombre.trim()) return 'Debe ingresar el nombre del servicio.';
    if (!servicio.descripcion.trim()) return 'Debe ingresar la descripción.';
    if (!servicio.paquetes || servicio.paquetes.length === 0) return 'Debe ingresar al menos un paquete.';
    for (const paquete of servicio.paquetes) {
      if (!paquete.nombre.trim() || !paquete.descripcion.trim() || !paquete.precio) {
        return 'Todos los paquetes deben tener nombre, descripción y precio.';
      }
      if (isNaN(Number(paquete.precio)) || Number(paquete.precio) <= 0) {
        return 'El precio del paquete debe ser un número mayor que cero.';
      }
    }
    return null;
  };

  // Guardar cambios
  const handleActualizarServicio = async (e) => {
    e.preventDefault(); // <-- evitar recarga

    if (!uid || !servicio) return;
    console.log('Ubicación a guardar:', servicio.ubicacion);

    try {
      setGuardando(true);
      let imagenURL = servicio.imagenURL;

      if (fotoFile) {
        const imageRef = ref(storage, `servicios/${uuidv4()}`);
        await uploadBytes(imageRef, fotoFile);
        imagenURL = await getDownloadURL(imageRef);
      }
      let nuevasPortafolioURLs = [...portafolioURLs]; // mantener los anteriores

      for (const file of portafolioFiles) {
        const refArchivo = ref(storage, `portafolio/${uuidv4()}_${file.name}`);
        await uploadBytes(refArchivo, file);
        const url = await getDownloadURL(refArchivo);
        nuevasPortafolioURLs.push({
          nombre: file.name,
          url,
          tipo: file.type.startsWith('image/') ? 'imagen' : 'pdf'
        });
      }

      const servicioActualizado = {
        ...servicio,
        imagenURL,
        portafolio: nuevasPortafolioURLs,
        fechaActualizacion: serverTimestamp(),
        ubicacion: servicio.ubicacion ?? null,
      };

      await updateDoc(doc(db, 'servicios', id), servicioActualizado);
      setMensaje('Servicio actualizado exitosamente');
      //navigate('/mis-servicios'); // redirige si quieres
    } catch (error) {
      console.error('Error actualizando servicio:', error);
      setMensaje('Hubo un error al actualizar el servicio');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <Navbar />
      <NavbarMobileVersion />

      <div className="crear-servicio-container">
        <h2>Editar Servicio</h2>

        <form onSubmit={handleActualizarServicio}>

          <label>Categoría</label>
          <select name="categoria" value={servicio.categoria} onChange={handleChange} required>
            <option value="">-- Seleccione categoría --</option>
            {categorias.map(cat => (
              <option key={cat.id} value={cat.label || cat.id}>{cat.label || cat.id}</option>
            ))}
          </select>

          <label>Nombre del Servicio</label>
          <input type="text" name="nombre" value={servicio.nombre} onChange={handleChange} required />

          <label>Descripción</label>
          <textarea name="descripcion" value={servicio.descripcion} onChange={handleChange} required />

          <label>Bio del Experto o Grupo</label>
          <textarea name="bio" value={servicio.bio} onChange={handleChange} placeholder="Experiencia, certificaciones..." />

          <label>Modalidad (Presencial, Virtual, Híbrido)</label>
          <input type="text" name="modalidad" value={servicio.modalidad} onChange={handleChange} />

          <label>Instrucciones para Reservar</label>
          <textarea name="instruccionesReserva" value={servicio.instruccionesReserva} onChange={handleChange} />

          <label>Foto referencial del servicio</label>
          <input type="file" accept="image/*" onChange={handleFotoChange} />

          {/* Preview imagen */}
          {fotoFile ? (
            <img
              src={URL.createObjectURL(fotoFile)}
              alt="Preview"
              style={{ width: 150, height: 150, objectFit: 'cover', marginTop: 10, borderRadius: 8 }}
            />
          ) : (
            servicio.imagenURL && (
              <img
                src={servicio.imagenURL}
                alt="Imagen servicio"
                style={{ width: 150, height: 150, objectFit: 'cover', marginTop: 10, borderRadius: 8 }}
              />
            )
          )}

          {/* FAQ Dinámico */}
          <fieldset>
            <legend>Preguntas Frecuentes (FAQ)</legend>
            {servicio.faq.map((item, i) => (
              <div key={i} className="faq-item">
                <input
                  type="text"
                  placeholder="Pregunta"
                  value={item.pregunta}
                  onChange={e => handleFaqChange(i, 'pregunta', e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Respuesta"
                  value={item.respuesta}
                  onChange={e => handleFaqChange(i, 'respuesta', e.target.value)}
                />
                {servicio.faq.length > 1 && (
                  <button type="button" onClick={() => eliminarFaq(i)}>Eliminar</button>
                )}
              </div>
            ))}
            {servicio.faq.length < 5 && (
              <button type="button" onClick={agregarFaq}>Agregar Pregunta</button>
            )}
          </fieldset>

          {/* Paquetes Dinámicos */}
          <fieldset>
            <legend>Paquetes Disponibles</legend>
            {servicio.paquetes.map((pqt, i) => (
              <div key={i} className="paquete-item">
                <textarea
                  placeholder="Nombre paquete"
                  value={pqt.nombre}
                  onChange={e => handlePaqueteChange(i, 'nombre', e.target.value)}
                  required
                  rows={4} // puedes ajustar las filas que quieres que tenga el textarea
                />

                <textarea
                  placeholder="Descripción paquete"
                  value={pqt.descripcion}
                  onChange={e => handlePaqueteChange(i, 'descripcion', e.target.value)}
                  required
                  rows={4} // más filas para descripción porque normalmente es más larga
                />

                <input
                  type="number"
                  placeholder="Precio"
                  value={pqt.precio}
                  onChange={e => handlePaqueteChange(i, 'precio', e.target.value)}
                  required
                  min="1"
                  step="0.01"
                />
                {servicio.paquetes.length > 1 && (
                  <button type="button" onClick={() => eliminarPaquete(i)}>Eliminar</button>
                )}
              </div>
            ))}
            {servicio.paquetes.length < 3 && (
              <button type="button" onClick={agregarPaquete}>Agregar Paquete</button>
            )}
          </fieldset>
          <label>Ubicación del servicio</label>
          {servicio && (
            <MapaSeleccion location={servicio.ubicacion} setLocation={setUbicacion} />
          )}

          <label>Archivos de Portafolio (PDF o Imágenes)</label>
          <input type="file" accept="image/*,.pdf" multiple onChange={handlePortafolioChange} />

          {/* Mostrar archivos subidos previamente */}
          <ul>
            {portafolioURLs.map((item, i) => (
              <li key={i}>
                {item.tipo === 'imagen' ? (
                  <img src={item.url} alt={item.nombre} width={100} />
                ) : (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">{item.nombre}</a>
                )}
              </li>
            ))}
          </ul>
          <ul>
            {portafolioFiles.map((file, i) => (
              <li key={i}>
                {file.name}
                <button type="button" onClick={() =>
                  setPortafolioFiles((prev) => prev.filter((_, j) => j !== i))
                }>Quitar</button>
              </li>
            ))}
          </ul>



          <button type="submit" disabled={guardando}>{guardando ? 'Guardando...' : 'Actualizar Servicio'}</button>
        </form>

        {mensaje && <p className="mensaje">{mensaje}</p>}
      </div><Footer />  </>
  );
};

export default EditarServicio;
